export const faqItems = [
  {
    id: 1,
    question: 'Qual é o alcance dos fones de ouvido sem fio?',
    answer: 'Nossos fones profissionais têm alcance de até 500 metros em área aberta, garantindo cobertura completa mesmo em grandes espaços como centros de convenções e auditórios. Em ambientes internos, o alcance efetivo é de 200-300 metros, suficiente para a maioria dos eventos corporativos.',
    relatedPost: {
      title: 'Palestra Silenciosa: O Que É, Como Funciona e Por Que Seu Evento Precisa Disso',
      slug: 'palestra-silenciosa-o-que-e-como-funciona-guia-completo',
    },
  },
  {
    id: 2,
    question: 'Quantos canais simultâneos são possíveis?',
    answer: 'Nossos sistemas suportam até 5 canais de áudio simultâneos, permitindo múltiplas palestras, idiomas ou trilhas de conteúdo ao mesmo tempo. Cada participante pode alternar livremente entre os canais através de controles simples nos fones.',
    relatedPost: {
      title: 'Conferência Silenciosa no Brasil: O Guia Definitivo',
      slug: 'conferencia-silenciosa-silent-conference-brasil-guia-completo',
    },
  },
  {
    id: 3,
    question: 'Quanto tempo leva para instalar o sistema?',
    answer: 'A instalação é rápida e simples. Para eventos de até 500 pessoas, o setup completo leva aproximadamente 2 horas, incluindo testes. Nossa equipe técnica chega com antecedência para garantir que tudo esteja funcionando perfeitamente antes do início do evento.',
    relatedPost: {
      title: 'Conferência Corporativa com Silent Conference: Guia Passo a Passo',
      slug: 'conferencia-corporativa-como-planejar-guia-completo',
    },
  },
  {
    id: 4,
    question: 'Vocês oferecem suporte técnico durante o evento?',
    answer: 'Sim! Todos os nossos pacotes incluem suporte técnico presencial durante todo o evento. Nossa equipe fica disponível para resolver qualquer questão técnica, auxiliar participantes e garantir que tudo funcione perfeitamente do início ao fim.',
    relatedPost: {
      title: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber',
      slug: 'locacao-fones-sem-fio-eventos-brasil',
    },
  },
  {
    id: 5,
    question: 'Os fones funcionam com tradução simultânea?',
    answer: 'Perfeitamente! Nosso sistema é ideal para eventos multilíngues. Cada canal pode transmitir um idioma diferente, e os participantes simplesmente selecionam o idioma desejado nos fones. Trabalhamos com tradutores profissionais ou podemos integrar seu time de tradução.',
    relatedPost: {
      title: 'Como Escolher Tecnologia de Áudio para Conferências Multilíngues',
      slug: 'como-escolher-tecnologia-audio-conferencias-multilingues',
    },
  },
  {
    id: 6,
    question: 'Qual é a duração da bateria dos fones?',
    answer: 'Nossos fones profissionais têm autonomia de 10-12 horas com uma única carga, suficiente para eventos de dia inteiro. Para eventos mais longos, oferecemos estações de recarga rápida e fones extras para garantir operação contínua.',
    relatedPost: {
      title: 'Palestra Silenciosa: O Que É, Como Funciona e Por Que Seu Evento Precisa Disso',
      slug: 'palestra-silenciosa-o-que-e-como-funciona-guia-completo',
    },
  },
  {
    id: 7,
    question: 'Qual área o sistema consegue cobrir?',
    answer: 'Nossos transmissores profissionais cobrem áreas de até 10.000m² com sinal de alta qualidade. Para espaços maiores, utilizamos múltiplos transmissores sincronizados que garantem cobertura uniforme sem pontos cegos ou interferências.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
  {
    id: 8,
    question: 'É possível gravar as palestras?',
    answer: 'Sim! Oferecemos serviço de gravação profissional de todos os canais de áudio. As gravações são entregues em formato digital de alta qualidade, perfeitas para criar conteúdo posterior, treinamentos ou arquivo institucional.',
    relatedPost: {
      title: 'Palestra Silenciosa para Treinamentos Corporativos',
      slug: 'palestra-silenciosa-treinamentos-corporativos-como-funciona',
    },
  },
  {
    id: 9,
    question: 'O sistema funciona em ambientes externos?',
    answer: 'Absolutamente! Nossos equipamentos são projetados para funcionar tanto em ambientes internos quanto externos. São resistentes a condições climáticas variadas e mantêm qualidade de áudio excepcional mesmo em espaços abertos.',
    relatedPost: {
      title: 'Silent Disco no Brasil: O Guia Completo sobre Festa Silenciosa',
      slug: 'silent-disco-brasil-festa-silenciosa-guia-completo',
    },
  },
  {
    id: 101,
    question: 'Mesmo sem filial na minha cidade, vocês atendem meu evento?',
    answer: 'Sim. A STIB tem sede em São Paulo e filial em Brasília, DF, além de equipamentos e profissionais presentes em Recife, Rio de Janeiro e Campinas. Atendemos eventos em todo o Brasil: nessas cidades a equipe já está na região; nas demais, equipe técnica e equipamentos são deslocados especialmente para cada evento. Não é necessário ter escritório local: transporte, instalação e suporte técnico presencial fazem parte do serviço em qualquer cidade atendida.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
  {
    id: 102,
    question: 'É possível contratar a STIB para eventos de órgãos públicos e licitações?',
    answer: 'Sim. Emitimos nota fiscal eletrônica e contrato, e temos experiência com os processos de dispensa, pregão eletrônico e inexigibilidade usados por órgãos públicos. Os equipamentos operam em frequência certificada pela Anatel, compatível com ambientes de segurança eletrônica.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
  {
    id: 103,
    question: 'Qual a diferença entre tradução simultânea e interpretação consecutiva?',
    answer: 'Na tradução simultânea, o intérprete traduz enquanto o palestrante fala, com poucos segundos de defasagem — é o formato mais comum em conferências e funciona com fones sem fio ou cabine. Na interpretação consecutiva, o palestrante fala um trecho, faz uma pausa, e o intérprete traduz em seguida — indicada para reuniões menores, rodadas de negócio e cerimônias, onde o ritmo mais pausado não é um problema.',
  },
  {
    id: 104,
    question: 'O orçamento inclui nota fiscal e contrato?',
    answer: 'Sim. Todo orçamento aprovado é formalizado com contrato e acompanhado de nota fiscal eletrônica, incluindo a documentação necessária para prestação de contas em empresas e órgãos públicos.',
  },
];

export const portfolioFaqItems = [
  {
    id: 1,
    category: 'Equipamentos',
    question: 'Que tipo de fones vocês utilizam?',
    answer: 'Utilizamos fones profissionais de última geração com tecnologia RF, cancelamento de ruído ativo, LEDs coloridos para identificação de canais e design ergonômico para conforto durante uso prolongado. Todos os equipamentos são higienizados após cada uso.',
    relatedPost: {
      title: 'Palestra Silenciosa: O Que É, Como Funciona e Por Que Seu Evento Precisa Disso',
      slug: 'palestra-silenciosa-o-que-e-como-funciona-guia-completo',
    },
  },
  {
    id: 2,
    category: 'Equipamentos',
    question: 'Os fones são confortáveis para uso prolongado?',
    answer: 'Sim! Nossos fones são especialmente projetados para eventos longos, com almofadas macias, ajuste de tamanho e peso reduzido (menos de 200g). Participantes relatam conforto mesmo após 8+ horas de uso contínuo.',
    relatedPost: {
      title: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber',
      slug: 'locacao-fones-sem-fio-eventos-brasil',
    },
  },
  {
    id: 3,
    category: 'Equipamentos',
    question: 'Quantos fones vocês têm disponíveis?',
    answer: 'Mantemos um inventário de mais de 5.000 fones profissionais, permitindo atender eventos de qualquer porte. Para eventos muito grandes, trabalhamos com parceiros para garantir disponibilidade ilimitada.',
    relatedPost: {
      title: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber',
      slug: 'locacao-fones-sem-fio-eventos-brasil',
    },
  },
  {
    id: 4,
    category: 'Equipamentos',
    question: 'Os equipamentos são higienizados?',
    answer: 'Todos os fones passam por processo rigoroso de higienização com produtos profissionais após cada uso. Utilizamos protocolos hospitalares de limpeza e oferecemos capas descartáveis individuais para máxima segurança sanitária.',
    relatedPost: {
      title: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber',
      slug: 'locacao-fones-sem-fio-eventos-brasil',
    },
  },
  {
    id: 5,
    category: 'Equipamentos',
    question: 'E se um fone apresentar defeito durante o evento?',
    answer: 'Sempre levamos 10-15% de equipamentos extras para substituição imediata. Nossa equipe técnica identifica e resolve problemas em minutos, garantindo que nenhum participante fique sem áudio.',
    relatedPost: {
      title: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber',
      slug: 'locacao-fones-sem-fio-eventos-brasil',
    },
  },
  {
    id: 6,
    category: 'Serviços',
    question: 'Vocês atendem eventos em outras cidades?',
    answer: 'Sim! Embora nossa base seja em São Paulo, atendemos eventos em todo o Brasil. Temos logística especializada para transporte seguro de equipamentos e equipes técnicas disponíveis em principais capitais.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
  {
    id: 7,
    category: 'Serviços',
    question: 'Oferecem serviço de tradução simultânea?',
    answer: 'Oferecemos dois modelos: podemos fornecer tradutores profissionais certificados em diversos idiomas, ou integrar com sua equipe de tradução existente. Nosso sistema é compatível com qualquer configuração de tradução.',
    relatedPost: {
      title: 'Como Escolher Tecnologia de Áudio para Conferências Multilíngues',
      slug: 'como-escolher-tecnologia-audio-conferencias-multilingues',
    },
  },
  {
    id: 8,
    category: 'Serviços',
    question: 'É possível personalizar os fones com nossa marca?',
    answer: 'Sim! Para eventos corporativos, oferecemos personalização com adesivos, capas customizadas ou até fones exclusivos com as cores e logo da sua empresa. Consulte nosso time comercial para opções e prazos.',
    relatedPost: {
      title: 'Eventos Corporativos em 2026: As 7 Tendências',
      slug: 'eventos-corporativos-tendencias-2026',
    },
  },
  {
    id: 9,
    category: 'Serviços',
    question: 'Vocês fazem a operação completa do evento?',
    answer: 'Podemos assumir desde apenas a locação de equipamentos até a operação técnica completa, incluindo instalação, configuração, treinamento de equipe, suporte durante o evento e desmontagem. Personalizamos o serviço conforme sua necessidade.',
    relatedPost: {
      title: 'Conferência Corporativa com Silent Conference: Guia Passo a Passo',
      slug: 'conferencia-corporativa-como-planejar-guia-completo',
    },
  },
  {
    id: 10,
    category: 'Logística',
    question: 'Com quanto tempo de antecedência devo reservar?',
    answer: 'Recomendamos reservar com pelo menos 30 dias de antecedência para garantir disponibilidade total. Para eventos grandes (1000+ pessoas) ou em datas concorridas, sugerimos 60-90 dias. Porém, já atendemos solicitações com 48h de antecedência.',
    relatedPost: {
      title: 'Conferência Corporativa com Silent Conference: Guia Passo a Passo',
      slug: 'conferencia-corporativa-como-planejar-guia-completo',
    },
  },
  {
    id: 11,
    category: 'Logística',
    question: 'Como funciona a entrega e retirada dos equipamentos?',
    answer: 'Nossa equipe entrega, instala e testa todos os equipamentos no local do evento. Após o término, fazemos a desmontagem e retirada. Todo o processo é coordenado com sua equipe para mínimo impacto na logística do evento.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
  {
    id: 12,
    category: 'Logística',
    question: 'Preciso de infraestrutura especial no local?',
    answer: 'Não! Nosso sistema é wireless e requer apenas tomadas elétricas padrão para os transmissores. Não é necessário cabeamento, instalações especiais ou modificações no espaço. Funciona em qualquer ambiente.',
    relatedPost: {
      title: 'Silent Disco no Brasil: O Guia Completo sobre Festa Silenciosa',
      slug: 'silent-disco-brasil-festa-silenciosa-guia-completo',
    },
  },
  {
    id: 13,
    category: 'Serviços',
    question: 'O que está incluído no serviço?',
    answer: 'Nossos pacotes incluem: locação de todos os equipamentos, transporte, instalação, configuração, testes, suporte técnico presencial durante o evento, desmontagem, seguro contra danos e higienização. Tudo para garantir uma experiência completa!',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },  {
    id: 105,
    question: 'A STIB tem equipamentos e profissionais em Recife, Rio de Janeiro e Campinas?',
    answer: 'Sim. Além da sede em São Paulo e da filial em Brasília, a STIB conta com equipamentos e profissionais presentes em Recife, Rio de Janeiro e Campinas. Isso agiliza a montagem, o suporte técnico presencial e o atendimento de eventos nessas cidades e regiões metropolitanas. Não há escritório físico nessas três cidades: a equipe e os equipamentos atuam em campo e o orçamento é centralizado pelo WhatsApp (11) 91777-6227.',
    relatedPost: {
      title: 'Palestra Silenciosa em Eventos: Tipos e Aplicações',
      slug: 'palestra-silenciosa-eventos',
    },
  },
];
